export default {
  // clearAuthData
  CLEAR_AUTH_DATA: "CLEAR_AUTH_DATA",
  // signinRedirectCallback
  START_SIGN_REDIRECT_CALLBACK: "START_SIGN_REDIRECT_CALLBACK",
  SIGN_REDIRECT_CALLBACK_SUCCESS: "SIGN_REDIRECT_CALLBACK_SUCCESS",
  SIGN_REDIRECT_CALLBACK_FAILED: "SIGN_REDIRECT_CALLBACK_FAILED",
}